import { useSidebar, useView } from "@/stores/ui";
import type { ViewType } from "@/types/workspace";
import { Flex } from "@mantine/core";
import { Activity, startTransition, useEffect, useMemo, useState } from "react";
import {
  WorkspaceContentJson,
  WorkspaceContentMap,
  WorkspaceContentTable,
} from "../";
import "./WorkspaceContent.css";

function getActivityMode(
  view: ViewType,
  targetView: ViewType
): "visible" | "hidden" {
  return view === targetView ? "visible" : "hidden";
}

export function WorkspaceContent() {
  const view = useView();
  const sidebar = useSidebar();
  const isSidebarOpen = sidebar.mode !== null && sidebar.isOpen;
  const [deferredView, setDeferredView] = useState<ViewType>(view);

  useEffect(() => {
    const oldView = deferredView;
    if (oldView !== view) {
      requestAnimationFrame(() => {
        startTransition(() => {
          setDeferredView(view);
        });
      });
    }
  }, [view, deferredView]);

  const className = useMemo(() => {
    return `workspace-content workspace-content-${deferredView}`;
  }, [deferredView, isSidebarOpen]);

  const isTableView = deferredView === "table";
  const style = useMemo(
    () => ({
      paddingLeft: isTableView && isSidebarOpen ? "350px" : "0",
    }),
    [deferredView, isSidebarOpen]
  );

  return (
    <Flex className={className} style={style}>
      <Activity mode={getActivityMode(deferredView, "map")}>
        <WorkspaceContentMap />
      </Activity>
      <Activity mode={getActivityMode(deferredView, "table")}>
        <WorkspaceContentTable />
      </Activity>
      <Activity mode={getActivityMode(deferredView, "json")}>
        <WorkspaceContentJson />
      </Activity>
    </Flex>
  );
}
